/**
 * HttpMethod dùng trong hệ thống.
 * Author: VHDuong (31/3/2021)
 */
export const HttpMethod = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  transaction: "api/Management/Logtransaction",
  transactioGroup: "/admin/transaction-group",
  transactionDetail: "/admin/transaction-details?id=",
};
export const BaseURL = {
  urlLocation: "https://localhost:44336/api/General/location?kind=",
};
/**
 * Các trạng thái của transaction
 * CreatedBy: PVPhong (20/04/2021)
 */
export const StatusTransactions = {
  create: "Yêu cầu thanh toán",
  process: "Đang xử lý",
  fail: "Thanh toán thất bại",
  success: "Thanh toán thành công",
  timeOut: "Hết hạn thanh toán",
  cancel: "Hủy giao dịch",
};

/**
 * Các loại thanh toán
 * CreatedBy: PVPhong (20/04/2021)
 */
export const PaymentTypes = {
  inland: "Thẻ nội địa",
  global: "Thẻ quốc tế",
  bank: "Tài khoản ngân hàng",
};
